module.exports = __webpack_public_path__ + "media/freeze.a8aec7d2.mp3";